import { useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'
import BottomContainer from '../components/BottomContainer/BottomContainer'
import FormOptin from '../components/FormOptin'
import Line from '../components/Line/Line'
import CategoryInfo from '../components/ResultsInfo/CategoryInfo'
import ResultsFooter from '../components/ResultsInfo/ResultsFooter'
import SeeResultsOptin from '../components/SeeResultsOptin'
import ShareBox from '../components/ShareBox'
import {
  QuizContextAction,
  QuizDispatchContext,
  QuizResults,
  QuizStoreContext,
} from '../contexts/quizContext'
import { category_info, isHiddenCategory } from '../data/features'
import { divId } from '../utils/functions'
import { useIsMobile } from '../utils/hooks'
import { R, T } from '../utils/Typography'

const ResultsRerenderProtector: React.FC = () => {
  const { quizResults } = React.useContext(QuizStoreContext)
  const reduceQuizData = React.useContext(QuizDispatchContext)

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return <Results quizResults={quizResults} reduceQuizData={reduceQuizData} />
}

type ResultsProps = {
  quizResults: QuizResults
  reduceQuizData: React.Dispatch<QuizContextAction>
}

const Results: React.FC<ResultsProps> = React.memo(
  ({ quizResults, reduceQuizData }) => {
    const isMobile = useIsMobile()
    // let { style } = useParams()
    // const [ query ] = React.useContext(QueryContext); //now receiving as string
    const history = useHistory()

    const _onClick = React.useCallback(() => {
      reduceQuizData({ type: 'reset_quiz' })
      history.push('quiz')
      //  <Link} to="/style-results"
    }, [history, reduceQuizData])

    const _onClickLearnMore = React.useCallback(() => {
      window.open('https://pineapplepodcasting.com/join-ppa')
    }, [])

    return (
      <div className='Almost-finished-page'>
        <div className='Style-container'>
          <Helmet>
            <title>Podcast Quiz: Almost Finished!</title>
            <meta
              id='meta-description'
              name='description'
              content='A detailed description of your artistic style based on answers from the style quiz!'
            />
            <meta
              id='og-title'
              property='og:title'
              content='Podcast Quiz: Results!'
            />
          </Helmet>

          <T variant='h2' style={{ fontFamily: 'Viva-Beautiful' }}>
            <b>Almost Finished!</b>
          </T>
          <T variant='h4'>Enter your info to see your results!</T>
          <SeeResultsOptin buttonText='Sign up!' />
        </div>
      </div>
    )
  },
)

export default ResultsRerenderProtector
